
const helper = {

	// Get header DOM node
	header: document.getElementById('hb-header'),

	// Get footer DOM node
	footer: document.getElementById('hb-footer'),

	// Get header container DOM node
	containerHeader: document.getElementById('hb-container-header'),

	// Get footer container DOM node
	containerFooter: document.getElementById('hb-container-footer'),

	object: {},

	classes: '',

	creatObject: function( obj ) {

		let object;

		switch (obj) {
			case 'body':
				object = document.body
				break;

			case 'window':
				object = window
				break;

			default:
				object = obj
				break;
		}

		this.object = object;
		this.classes = this.object.classList;
		return this;
	},

	css: function( args ) {
		if ( 'object' === typeof args ) {
			for ( let key in args ) {
				this.object.style[ key ] = args[ key ];
			}
		}
		return this;
	},

	// manage class for elements
	addClass: function( c ) {
		this.object.classList.add( c );
		return this;
	},

	// manage class for elements
	removeClass: function( c ) {
		this.object.classList.remove( c );
		return this;
	},

	// manage class for elements
	hasClass: function( c ) {
		return this.object.classList.contains( c );
	},

	// adding text to element
	text: function( text ) {
		var textNode = document.createTextNode( text );
		this.object.appendChild( textNode );
		return this;
	},

	// manage add attribute(s) for elements
	removeAttr: function( attr ) {
		this.object.removeAttribute( attr );
		return this;
	},

	// manage add attribute(s) for elements
	setAttr: function( attr, value ) {
		if ( 'object' === typeof attr ) {
			for ( let key in attr ) {
				this.object.setAttribute( key , attr[ key ] );
			}
		} else if ( 'string' === typeof attr ) {
			this.object.setAttribute( attr, value );
		}

		return this;
	},

	getSize: function( elem, h, w ) {
		return Math.max(
			elem.documentElement["client" + name],
			elem.body["scroll" + name], elem.documentElement["scroll" + name],
			elem.body["offset" + name], elem.documentElement["offset" + name]
		);
	},

	getPosition: function( element = null ) {
		let el = element ? element : this.object;
		let x = 0, y = 0;
		while( el && !isNaN( el.offsetLeft ) && !isNaN( el.offsetTop ) ) {
			x += el.offsetLeft - el.scrollLeft;
			y += el.offsetTop - el.scrollTop;
			el = el.offsetParent;
		}
		return { top: y, left: x };
	},

	/**
	 * debug code
	 */
	debug: function( text ) {
		const debugBox = document.createElement('DIV');
		debugBox.classList.add('hayya_debug');

		const obj = this.creatObject(debugBox);

		obj.css({
			position: 'fixed',
			top: '32px',
			left: 0,
			backgroundColor: '#FF0000',
			color: '#FFFFFF',
			display: 'inline-block',
			minWidth: '50px',
			height: '30px',
			zIndex: 99999,
			opacity: .7,
			textAlign: 'center',
		}).text(text);

		document.body.append(debugBox);

	}

};

export default helper;
